// extracted by mini-css-extract-plugin
export default {"container":"Header_container__G4ar6","info":"Header_info__63F-q","btnBack":"Header_btnBack__X0JJP"};